import React from "react";
import dropdown from "../../assets/dropdown.svg";
import checkIcon from "../../assets/ic_check.svg";
import "./styles.css";

const PREFIXES = [
  "770",
  "771",
  "772",
  "773",
  "774",
  "776",
  "777",
  "778",
  "779",
  "220",
  "221",
  "222",
  "223",
  "224",
  "225",
  "226",
  "227",
  "228"
];

class Dropdown extends React.Component {
  state = {
    showDropdown: false
  };
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handlePrefixClick = e => {
    const value = e.target.value.replace(/\D/g, "");
    this.props.onChange(value);
    this.setState({ showDropdown: false });
  };
  handleClickOutside = e => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({ showDropdown: false });
    }
  };
  handleClick = () => this.setState({ showDropdown: !this.state.showDropdown });
  render() {
    const { showDropdown } = this.state;
    return (
      <div
        ref={node => {
          this.wrapperRef = node;
        }}
        className={showDropdown ? "dropdown dropdown--active" : "dropdown"}
      >
        <div className="dropdown-preview" onClick={this.handleClick}>
          <span className="dropdown__value">
            {this.props.value || this.props.text}
          </span>
          <img src={dropdown} width="12" alt="dropdown-icon" />
        </div>
        <div className="dropdown-mobile-preview" onClick={this.handleClick}>
          <span className="dropdown__value">
            {this.props.value || this.props.mobileText}
          </span>
          <img src={dropdown} width="12" alt="dropdown-icon" />
        </div>
        <div className="mobile-dropdown__bg" onClick={this.handleClick} />
        <div className="dropdown-menu ">
          <div className="mobile-dropdown">
            <div className="mobile-dropdown__content">
              <label className="dropdown-menu__item">
                {this.props.text}
                <input
                  type="radio"
                  name="prefix-radio"
                  onChange={this.handlePrefixClick}
                />
                <img src={checkIcon} alt="check-icon" />
              </label>
              {PREFIXES.map(item => (
                <label className="dropdown-menu__item" key={item}>
                  {item}
                  <input
                    type="radio"
                    name="prefix-radio"
                    value={item}
                    onChange={this.handlePrefixClick}
                  />
                  <img src={checkIcon} alt="check-icon" />
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Dropdown;
